import React, { useEffect, useState, useContext } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { StateController } from './../../App';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import { sendDataLayer } from '../../utils/functions';

function Mechanic() {
    const { context } = useContext(StateController);
    const segment = String(context?.user?.segment ?? '');
    console.log("segmento", segment)


    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 998);
        };
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (window.location.pathname.includes("landing")) {
            document.body.classList.add("landing-page");
        } else {
            document.body.classList.remove("landing-page");
        }
    }, []);

    const click_tyc = () => {
        sendDataLayer({ datalayer: ({ 
            event: "mecanic", 
            text: "Aplica términos y condiciones", 
            link: "/terminos-y-condiciones", 
            site_url: window.location.href }), 
        repeat: true })
    }

    return (
        <div className='mc-page mechanic slow_ani mc-container-landing'>
            {
                segment === '1' ? (
                    <div className='__page'>
                        <div className='__text'>
                            <div className="__container">
                                <div>
                                    <h1>Mecánica</h1>
                                </div>
                                <p>Sigue estos pasos y gana con tu Tarjeta de Débito Mastercard:</p>
                            </div>
                        </div>
                        <div className='__cards-container'>
                            {isMobile ? (<div className='__cards-container-vertical'>
                                <div className='__card'>
                                    <div className='__img'>
                                        <img src='/assets/images/sli1_A_M.png' alt="" />
                                    </div>
                                    <div className='__text-card'>
                                        <div className='number'>
                                            <strong>1</strong>
                                        </div>
                                        <p data="&lt;b&gt;Descubre tu objetivo y en qué categorías debes consumir&lt;/b&gt; para ganar premios increíbles."><b>Descubre tu objetivo y en qué categorías debes consumir</b> para ganar premios increíbles.</p>
                                    </div>
                                </div>
                                <div className='__card'>
                                    <div className='__img'>
                                        <img src='/assets/images/sli2_A_M.png' alt="" />
                                    </div>
                                    <div className='__text-card'>
                                        <div className='number'>
                                            <strong>2</strong>
                                        </div>
                                        <p data="&lt;b&gt;Usa tu Tarjeta Mastercard Débito en todas tus compras&lt;/b&gt; para alcanzar las objetivos."><b>Usa tu Tarjeta Mastercard Débito en todas tus compras</b> para alcanzar las objetivos.</p>
                                    </div>
                                </div>
                                <div className='__card'>
                                    <div className='__img'>
                                        <img src='/assets/images/sli3_A_M.png' alt="" />
                                    </div>
                                    <div className='__text-card'>
                                        <div className='number'>
                                            <strong>3</strong>
                                        </div>
                                        <p data="&lt;b&gt;Canjea la e-Gift Card que más te guste.&lt;/b&gt; Sigue consumiendo y participa para ganar el premio mayor."><b>Canjea la e-Gift Card que más te guste.</b> Sigue consumiendo y participa para ganar el premio mayor.</p>
                                    </div>
                                </div>
                                <div className='__card'>
                                    <div className='__img'>
                                        <img src='/assets/images/Sli4_A_M.png' alt="" />
                                    </div>
                                    <div className='__text-card'>
                                        <div className='number'>
                                            <strong>4</strong>
                                        </div>
                                        {/* <p><strong>4.</strong>  Mientras más veces alcances tu meta mas probabilidades tendrás de participar por un increíble viaje a Río de Janeiro o un Kit de Apple.<br /></p> */}
                                        <p><b>Gana un viaje para dos personas.</b>   Cada vez que cumplas tu objetivo sumarás oportunidades para ganar.</p>
                                            <h6><a style={{ color: '#D2006E' }} target='_blank' onClick={click_tyc} href="/GanaConMastercardDebit/terminos-y-condiciones">*Aplican términos y condiciones</a></h6>

                                    </div>
                                </div>
                            </div>
                            ) : (<Swiper
                                navigation={{
                                    nextEl: '.swiper-button-next-custom',
                                    prevEl: '.swiper-button-prev-custom'
                                }}
                                cssMode={true}
                                pagination={{ clickable: true }}
                                mousewheel={true}
                                keyboard={true}
                                modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                                className='__swiper'
                                spaceBetween={15}
                                slidesPerView={4}
                                loop={false}
                            >
                                <SwiperSlide>
                                    <div className='__card'>
                                        <div className='__img'>
                                            <img src='/assets/images/sli1_A.png' alt="" />
                                        </div>
                                        <div className='__text-card'>
                                            <div className='number'>
                                                <strong>1</strong>
                                            </div>
                                            <p><b>Descubre tu objetivo y en qué categorías debes consumir</b> para ganar premios increíbles.</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='__card'>
                                        <div className='__img'>
                                            <img src='/assets/images/sli2.png' alt="" />
                                        </div>
                                        <div className='__text-card'>
                                            <div className='number'>
                                                <strong>2</strong>
                                            </div>
                                            <p><b>Usa tu Tarjeta Mastercard Débito en todas tus compras</b> para alcanzar las objetivos.</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='__card'>
                                        <div className='__img'>
                                            <img src='/assets/images/sli3_A.png' alt="" />
                                        </div>
                                        <div className='__text-card'>
                                            <div className='number'>
                                                <strong>3</strong>
                                            </div>
                                            <p><b>Canjea la e-Gift Card que más te guste.</b> Sigue consumiendo y participa para ganar el premio mayor.</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='__card'>
                                        <div className='__img'>
                                            <img src='/assets/images/sli4.png' alt="" />
                                        </div>
                                        <div className='__text-card'>
                                            <div className='number'>
                                                <strong>4</strong>
                                            </div>
                                            {/* <p><strong>4.</strong> Mientras más veces alcances tu meta mas probabilidades tendrás de participar por un increíble viaje a Río de Janeiro o un Kit de Apple.<br /></p> */}
                                            <p><b>Gana un viaje para dos personas.</b> Cada vez que cumplas tu objetivo sumarás oportunidades para ganar.</p>
                                               <h6><a style={{ color: '#D2006E' }} target='_blank' onClick={click_tyc} href="/GanaConMastercardDebit/terminos-y-condiciones">*Aplican términos y condiciones</a></h6>

                                        </div>
                                    </div>
                                </SwiperSlide>
                                <div className="swiper-pagination"></div>
                            </Swiper>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className='__page'>
                        <div className='__text'>
                            <div className="__container">
                                <div>
                                    <h1>Mecánica</h1>
                                </div>
                                <p>Sigue estos pasos y gana con tu Tarjeta de Débito Mastercard:</p>
                            </div>
                        </div>
                        <div className='__cards-container'>
                            {isMobile ? (<div className='__cards-container-vertical'>
                                <div className='__card'>
                                    <div className='__img'>
                                        <img src='/assets/images/sli2_I_M.png' alt="" />
                                    </div>
                                    <div className='__text-card'>
                                        <div className='number'>
                                                <strong>1</strong>
                                        </div>
                                            <p><b>Las compras que haces</b> con tu Tarjeta de Débito Mastercard te premian.</p>
                                    </div>
                                </div>
                                <div className='__card'>
                                    <div className='__img'>
                                        <img src='/assets/images/sli1_I_M.png' alt="" />
                                    </div>
                                    <div className='__text-card'>
                                        <div className='number'>
                                                <strong>2</strong>
                                            </div>
                                            <p><b>Conoce tu objetivo y realiza todas las compras</b> con tu Tarjeta de Débito Mastercard para alcanzarla.</p>
                                    </div>
                                </div>
                                <div className='__card'>
                                    <div className='__img'>
                                        <img src='/assets/images/sli3_I_M.png' alt="" />
                                    </div>
                                    <div className='__text-card'>
                                        <div className='number'>
                                                <strong>3</strong>
                                            </div>
                                            <p><b>¡Elige tu e-Gift Card favorita y canjéala</b> en las tiendas disponibles!</p>
                                    </div>
                                </div>
                                <div className='__card'>
                                    <div className='__img'>
                                        <img src='/assets/images/sli4_I_M.png' alt="" />
                                    </div>
                                    <div className='__text-card'>
                                        <div className='number'>
                                                <strong>4</strong>
                                            </div>
                                        <p><b>Participa por un viaje; </b>Cada vez que cumplas tu objetivo sumarás oportunidades para ganar.</p>
                                            <h6><a style={{ color: '#D2006E' }} target='_blank' onClick={click_tyc} href="/GanaConMastercardDebit/terminos-y-condiciones">*Aplican términos y condiciones</a></h6>
                                    </div>
                                </div>
                            </div>
                            ) : (<Swiper
                                cssMode={true}
                                navigation={true}
                                pagination={{ clickable: true }}
                                mousewheel={true}
                                keyboard={true}
                                modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                                className='__swiper'
                                spaceBetween={15}
                                slidesPerView={4}
                                loop={false}
                            >
                                <SwiperSlide>
                                    <div className='__card'>
                                        <div className='__img'>
                                            <img src='/assets/images/sli2.png' alt="" />
                                        </div>
                                        <div className='__text-card'>
                                            <div className='number'>
                                                <strong>1</strong>
                                            </div>
                                            <p><b>Las compras que haces</b> con tu Tarjeta de Débito Mastercard te premian.</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='__card'>
                                        <div className='__img'>
                                            <img src='/assets/images/sli1.png' alt="" />
                                        </div>
                                        <div className='__text-card'>
                                            <div className='number'>
                                                <strong>2</strong>
                                            </div>
                                            <p> <b>Conoce tu objetivo y realiza todas las compras</b> con tu Tarjeta de Débito Mastercard para alcanzarla.</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='__card'>
                                        <div className='__img'>
                                            <img src='/assets/images/sli3.png' alt="" />
                                        </div>
                                        <div className='__text-card'>
                                            <div className='number'>
                                                <strong>3</strong>
                                            </div>
                                            <p><b>¡Elige tu e-Gift Card favorita y canjéala</b> en las tiendas disponibles!</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='__card'>
                                        <div className='__img'>
                                            <img src='/assets/images/sli4.png' alt="" />
                                        </div>
                                        <div className='__text-card'>
                                            <div className='number'>
                                                <strong>4</strong>
                                            </div>
                                            <p><b>Participa por un viaje;</b> Cada vez que cumplas tu objetivo sumarás oportunidades para ganar.</p>
                                            {/* <p><strong>4.</strong> ¡El premio mayor puede ser tuyo!<br /></p> */}
                                            <h6><a style={{ color: '#D2006E' }} target='_blank' onClick={click_tyc} href="/GanaConMastercardDebit/terminos-y-condiciones">*Aplican términos y condiciones</a></h6>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <div className="swiper-pagination"></div>
                            </Swiper>
                            )}
                        </div>
                    </div>
                )
            }
        </div>
    )
}
export default Mechanic